<template>
  <modal v-if='thankYou' ref="thankyou">
    <div class="thankyou">
      <h2>Awesome!</h2>
      <p>You're on your way to remove manual tasks!</p>
      <img src="~@/assets/img/safe-online-logo.jpg" alt="DataMapper logo" />
    </div>
  </modal>
  <modal v-else ref="signup" :onClosed="onClosed">
    <form action="https://forms.hubspot.com/uploads/form/v2/3937313/0bbfd302-252b-4759-a1b7-d36c71266e88" method="post" class="grid email-signup">
      <h3>Sign up to be an early beta tester</h3>
      <div class="unit w-1-2">
        <label for="firstName">
          First Name:
          <input type="text" id="firstName" name="firstName" placeholder="Your first name" required />
        </label>
      </div>
      <div class="unit w-1-2">
        <label for="lastName">
          Last Name:
          <input type="text" id="lastName" name="lastName" placeholder="Your last name" required />
        </label>

      </div>
      <div class="unit w-1-2">
        <label for="jobTitle">
          Job title:
          <input type="text" id="jobTitle" name="jobTitle" placeholder="Your title" required />
        </label>
      </div>
      <div class="unit w-1-2">
        <label for="companyName">
          Company:
          <input type="text" id="companyName" name="companyNAme" placeholder="Company name" required />
        </label>
      </div>
      <div class="unit w-1-2">
        <label for="signupEmail">
          Email:
          <input type="email" id="signupEmail" name="email" placeholder="Company email" required />
        </label>
      </div>
      <div class="unit w-1-2 cta">
        <button class="simple">Sign up</button>
      </div>

      <input type="hidden" name="hs_context" :value='hsContext' />
    </form>
  </modal>
</template>

<script>

const hsContext = JSON.stringify({ // For hubspot
  redirectUrl: window.location.href
})

import Config from 'config'
import events from './events.js'
import Modal from '@/comps/Modal'
import { setMetaInfo } from '@/utils'

export default {
    components: {Modal},
    data () {
        return {
            thankYou: false,
            hsContext,
            previousMeta: {}
        }
    },

    created () {

        events.$on('open', () => {
            this.openSignupModal()
        })

        events.$on('thanks', () => {

            this.openThanks()
        })
    },

    methods: {
        openSignupModal () {

            this.previousMeta = {
                title: document.title,
                metaTag: document.head.querySelector('meta[name=description]').content
            }

            setMetaInfo(Config.metaPageInfo['/signup'])

            this.thankYou = false

            history.pushState({ // to add '?signup' in URL without causing a page load
                showSignupPopup: true
            }, '', '?signup')

            this.$nextTick(() => this.$refs.signup.open())
        },
        onClosed () {
            history.pushState({ // remove '?signup' from the URL when the popup is closed
                showSignupPopup: false
            }, '', location.pathname)

            setMetaInfo(this.previousMeta)
        },
        openThanks () {
          this.thankYou = true
          this.$nextTick(() => this.$refs.thankyou.open())
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// apps/comps/SignupModal/SignupModal.vue